export enum CaseTypeEnum {
	Quadrant = 1,
	FullArch = 2,
	StudyModel = 3,
	Expanded = 4,
	iCast = 5,
	ReferenceModel = 6,
	VS = 11,
	iQ = 12,
	iRecord = 13,
	Invisalign = 30,
	Realine = 31,
	Vivera = 32,
	ViveraPDB = 33,
	InvisalignAndiRecord = 34,
	ReferenceScan = 35,
	SmileDirectClub = 36,
	ChairsideMilling = 40,
	DentaliRecord = 41,
	ChairsideMillingGlidewellIo = 42,
	InvisalignFirst = 43,
	ChairsideMillingCerec = 44,
	Restorative = 50,
	Diagnostics = 99,
}

export enum ProcedureEnum {
	StudyModel_iRecord = 1,
	Invisalign = 2,
	ImplantPlanning = 3,
	FixedRestorative = 4,
	Denture_Removable = 5,
	Appliance = 6,
}

export enum ExportTypeFormatEnum {
	None = 0,
	OpenShell = 1,
	SolidModelWithLowProfileBase = 4,
	HollowABOBase = 5,
	SolidABOBase = 8,
}

export enum ExportDataFormatEnum {
	Unknown = 0,
	TwoFiles_EachArchWithTeethUp = 3,
	TwoFiles_ArchesOrientedInOcclusion = 2,
	OneFile_ArchesLockedInOcclusion = 1,
}

export enum FileTypeParallelEnum {
	Unknown = 0,
	STL = 1,
	PLY = 2,
	STL_PLY = 3,
}

export enum ViewerSources {
	CallFromEupApi = 1,
}

export enum ExportStatus {
	NoStatus = -1,
	Created = 1,
	Released = 2,
	Active = 3,
	Completed = 4,
	Failed = 5,
	Canceled = 6,
}

export enum RoleTypeEnum {
	Lab = 1,
	Internal = 5,
}

export enum UserRoleTypeEnum {
	None = 0,
	Admin = 1 << 0,
	FullOrdersVisibility = 1 << 1,
	PrimaryContact = 1 << 2,
}

export enum ExcelExtensionsEnum {
	Xlsx,
	Xls,
	Csv,
}

export enum Appearance {
	Dark = 1,
	Light,
}

export enum LabCasesState {
	CurrentCases,
	PendingCases,
	TotalCases,
}

export enum FeatureToggle {
	NotificationServiceEnabled = 'NotificationService.Enabled',
	EupLocalFlagsOverrideGlobal = 'eup-local-flags-override-global',
	UndoReturnVisibility = 'undo-return-visibility',
	PatientConsentEnabled = 'patient-consent-enabled',
	PracticeManagement = 'PracticeManagement',
	AdvancedPracticeManagement = 'AdvancedPracticeManagement',
	PracticeManagementLabs = 'PracticeManagementLabs',
	TextureMappingEnabled = 'TextureMapping.IsEnabled',
	IOSimPlusFeatureFlag = 'IOSimPlus.Enabled',
	IdsPairingForIOSIM = 'ids-pairing-for-iosim',
	RedirectionCN = 'redirection-cn',
	ReferralWorkflow = 'Referral Workflow',
	InvitationFlowEnabled = 'invitation-flow-enabled',
	PracticeNameColumnInLabEnabled = 'enable-practice-name-column-for-lab',
	ProcedureBasedRx = 'Procedure Based Rx',
	SplunkRum = 'use-splunk-rum',
	UseSctAuthorization = 'use-sct-authorization',
	EnableLoginFallback = 'enable-login-fallback',
	ForceExocadCaseTriage = 'ForceExocadCaseTriage',
	EnableExocadViewer = 'enable-exocad-viewer',
	EmailNotifications = 'EmailNotifications',
	DisplayNotificationsTab = 'display-notifications-tab',
	CaseStatusUpdatebyLabMIDC = 'Case Status Update by Lab - MIDC',
	DisplayOrderStatusColumnMIDC = 'display-order-status-column',
	OrderStatusColumnMAT = 'OrderStatusColumn',
	SendToColumnMAT = 'SendToColumn',
	DisplaySendToColumnMIDC = 'display-send-to-column',
	DateModifiedColumnMIDC = 'date-modified-column',
	DateModifiedColumnMAT = 'DateModifiedColumn',
	IteroAnalyticsMIDC = 'display-itero-analytics',
	IteroAnalyticsMAT = 'iTeroAnalytics',
	DownloadViaLink = 'download-via-link',
	POIFeatureFlag = 'POIUI.ReaderStudy.Enabled',
	AgreementMessageLab = 'ShowAgreementMessageWinInMidcLab',
	LabConnectTab = 'LabConnectTab',
	SubscribeExportFilesOnlyOnce = 'subscribe-export-files-only-once',
	ShowLaunchBannerInMyitero = 'ShowLaunchBannerInMyitero',
	PublishNewContextSchemaToViewer = 'publish-new-context-schema-to-viewer',
	OpenAohsUI = 'AlignOralHealthSuiteClient',
	PendingNotification = 'pending-notification',
	EnableExocadMiniAppInstallerSSO = 'EnableExocadMiniAppInstallerSSO',
	AMUIEnabled = 'AM-UI-Enabled',
	Auth0IsEnabled = 'Auth0IsEnabled',
	IMSUserFlow = 'IMS.UserFlow',
	PendoToggle = 'PendoToggle',
	PendoInitOnAppStart = 'PendoInitOnAppStart',
	CompanySoftwareOptionsKeyValuePair = 'CompanySoftwareOptionsKeyValuePair',
	EnablePlatformSelector = 'EnablePlatformSelector',
	EnableAMUINewStandardLaunch = 'Enable_AMUI_New_Standard_Launch',
	MiflEnableAccountManagementUISL = 'MIFL_Enable_AMUI_SL',
	UseIteroPlatformLogin = 'UseIteroPlatformLogin',
}

export enum AssetReferenceType {
	OrderId = 1,
	ParallelWorkOrderId = 2,
	ActivityId = 3,
	IdeSalesOrderDetailsId = 4,
	Fms_none = 5,
	Fms_3ds = 6,
	Fms_3dc = 7,
	Fms_3dz = 8,
	Fms_gCode = 9,
	Fms_catalog = 10,
	Fms_images = 11,
	Fms_3dm = 12,
	Fms_fs3dm = 13,
	Fms_evx = 14,
	Fms_niri = 15,
	Fms_capture = 16,
}

export enum Language {
	DEDE = 'de-DE',
	ENUS = 'en-US',
	ESES = 'es-ES',
	FRFR = 'fr-FR',
	ITIT = 'it-IT',
	JAJP = 'ja-JP',
	KOKR = 'ko-KR',
	PTBR = 'pt-BR',
	RURU = 'ru-RU',
	THTH = 'th-TH',
	TRTR = 'tr-TR',
	ZHCN = 'zh-CN',
	ZHTW = 'zh-TW',
}

export enum FileType {
	Evx = 9,
	Niri = 10,
	Capture = 11,
}

export enum WindowsApplicationProtocol {
	IteroLab = 0,
	OrthoCad = 1,
}

export enum PrintFormat {
	Vertical = 1,
	Horizontal = 2,
}

export enum GenderType {
	Male = 0,
	Female = 1,
	Empty = '',
}

export enum BillOfWorkType {
	Inactive = -3,
	Cancelled = -2,
	Completed = -1,
	Scanning = 100,
	ReadyForDownload = 131,
	Doctor_Review = 150,
	Model_Printing = 170,
	Interpretation = 500,
	LabReview = 510,
	iDX = 513,
}

export enum StorageType {
	ACS = 0,
	OriginalFMS = 1,
}

export enum ViewerSoftwareOptions {
	ShouldEnableEvx = 2087,
	ShouldEnableIntraoralCameraTool = 2092,
	ShouldEnableTextureMappingInViewer = 2230,
	NGNIRI = 2430,
}

export enum SnapshotSoftwareOptions {
	ShouldDisableDrawingTool = 2093,
	ShouldDisableCaptureTool = 2094,
}

export enum SoftwareOptionsForCompany {
	ShouldDisableTextureMapping = 2231,
	shouldDisablePatientManagement = 2118,
	shouldDisableHidePatientDetails = 2110,
	shouldEnableVisitReportMidc = 2220,
	shouldEnableVisitReportScanner = 2225,
	referralWorkflowPractice = 2238,
	AccountManagement = 2240,
	InvisalignOutcomeSimulator = 2249,
	ProgressAssesment = 2250,
	CaseAssesment = 2251,
	AllowExocadCaseTriage = 2407,
	EmailNotifications = 2411,
	CaseStatusUpdatebyLabMIDC = 2413,
	iTeroAnalytics = 2424,
	cswo_IteroChatHub = 2617,
	POIUIReaderStudy = 2441,
	LabConnectTab = 2418,
	AlignOralHealthSuiteClient = 2464,
	ImageGallery = 2482,
	NewAnnotationTool = 2488,
	LabAgreement = 2490,
	cswo_DirectToModelingForLumina = 2499,
	cswo_PracticeConnectionsTab = 2497,
	cswo_UseMiflPlatform = 2524,
	cswo_Hide_OrthoCAD_Show_3DM = 2522,
	cswo_MaterialSpecificationCustomizedRx = 2526,
	'cswo_UseWeb3DTool2.0' = 2682,
	Web3dToolV2MIFL = 2729,
	MIFLEnableEntitySelector = 2737,
	LabWithCustomRxSettings = 2768,
}

export enum ToothNumberingSystem {
	FDI = 0,
	ADA = 1,
	QUADRANT = 2,
}

export enum AppMode {
	EUP = 'eup',
	SCANNER = 'scanner',
}

export enum RxAppApplicationModeEnum {
	Web = 'Web',
	Scanner = 'EmbeddedInScanner',
}

export enum Origin {
	WebGroup = 0,
	Global = 1,
}

export enum PatientType {
	Itero = 1,
	IDS = 2,
	Paired = 3,
}

export enum ContactType {
	None,
	ExtStaff_WCM = 8,
	ExtStaff_Lab = 9,
	ExtStaff_ClinicalOffice = 10,
	Model_Printing = 12,
	IntStaff_ITOPs = 13,
	ExtStaff_OrthoCADDistributor = 14,
	ExtStaff_iTeroDistributor = 15,
	ExtStaff_Invisalign = 16,
	ExtStaff_ProductionCenterResource = 17,
	ExtStaff_MillingSitePersonnel = 18,
	Dentist = 19,
	Orthodontist = 20,
	Dental_Office_Personnel = 21,
	Ortho_Office_Personnel = 22,
	Cadent_Personnel = 23,
	ExtStaff_InvisalignOutcomeSimulatorUser = 24,
	Management_Company_Personnel = 25,
	Operational_Office_Personnel = 26,
	Clinical_Office_Personnel = 27,
	General_User_For_Company = 28,
}

export enum Features {
	patientAppEnabledForMyItero = 1,
}

export enum ScannerModel {
	element = 'element',
	evx = 'evx',
	other = 'other',
}

export enum AccountPairingStatus {
	Unknown = 1,
	Failed = 2,
	NotPaired = 3,
	InProgress = 4,
	Paired = 5,
}

export enum MessengerType {
	WeChat = 1,
}

export enum CountryCode {
	China = 47,
}

export enum Regions {
	china = 'cn-north-1',
	apac = 'ap-northeast-1',
	us1 = 'us-west-1',
	us2 = 'us-west-2',
	eu = 'eu-central-1',
}

export enum ContactTypeGroup {
	notSet = -1,
	internalTechnicalUser = 1,
	internalNonTechnicalUser = 2,
	externalTechnicalUser = 3,
	externalNonTechnicalUser = 4,
	externalLabUser = 5,
}

export enum RowStatus {
	Active = 1,
	Cancelled = 2,
	Deleted = 5,
	InActive = 6,
	Resolved = 8,
}

export enum RxStatus {
	RxCreated = 1,
	Scanning = 2,
	Sending = 3,
	FailedToSend = 4,
	Sent = 5,
	Returned = 7,
	ReferralCreated = 8,
	ReferralDrafted = 9,
	PendingAttachment = 10,
}

export enum TreatmentStageEnum {
	InitialRecord = 1,
	ProgressRecord = 2,
	FinalRecord = 3,
}

export enum RequestOriginScreen {
	Orders = 'Orders',
	PatientOrders = 'PatientOrders',
}

export enum ThirdPartyIntegrations {
	exocad = 'exocad',
}

export enum BusinessPartnerTypeNames {
	DentalOffice = 'Dental Office',
	AlignInternalOffice = 'Align (Internal office)',
	OrthodonticOffice = 'Orthodontic Office',
	ClinicalOffice = 'Clinical Office',
	Lab = 'Lab',
	ExternalDentalLab = 'External Dental Lab',
	OnlineDentalLab = 'Online Dental Lab',
	LabGroup = 'Lab Group',
	iTeroCBFAB = 'iTero C&B FAB',
	MillingSite = 'Milling Site',
	ModelQCStation = 'Model QC Station',
	OrthoDistributor = 'Ortho Distributor',
	WorkCenter = 'Work center',
	iTeroWarehouse = 'iTero warehouse',
	Distributor = 'Distributor',
	DistributorRegOf = 'Distributor Reg. Of.',
	ProductionCenter = 'Production Center',
	InterpretationSite = 'Interpretation Site',
	ManagementCompanyGroupAccount = 'Management Company / Group Account',
	PracticeManagementSoftwareVendor = 'Practice - Management Software Vendor',
	Invisalign = 'Invisalign',
	GCodeSite = 'GCode Site',
	OrthoModelingSite = 'Ortho Modeling Site',
	iTeroModelingSite = 'iTero Modeling Site',
	TraditionalOrthoScanningCenter = 'Traditional Ortho Scanning Center',
	iQFabricationCenter = 'iQ Fabrication Center',
	iDESite = 'iDE Site',
	AlignExportSite = 'Align Export Site',
	University = 'University',
	Group = 'Group',
	Hospital = 'Hospital',
	TerritoryManager = 'Territory Manager',
	IntercompanyAccount = 'Intercompany Account',
	ParallelWeb3DSite = 'Parallel Web 3D Site',
	ParallelIDESite = 'Parallel iDE Site',
	ScanningCenter = 'Scanning Center',
	PrintingSite3D = '3D Printing Site',
	PartnerThirdPartySW = 'Partner - 3rd party SW',
	ReferralOffice = 'Referral Office',
}

export enum BusinessPartnerType {
	PartnerThirdPartySW = 3200,
	Lab = 300,
	Externallab = 320,
	LabOnline = 340,
	LabType = 399,
	Clinic = 200,
}

export enum BusinessPartnerPreference {
	CustomRxSettings = 121,
}

export enum GroupedStatus {
	Open = 1,
	InProgress = 2,
	AttentionFromTheDoctor = 3,
	Completed = 4,
}

export enum LabOrderStatus {
	Returned = 'Returned',
	iTeroModeling = 'iTero Modeling',
}

export enum SettingsKeys {
	SelectedLanguage = 'SelectedLanguage',
}
export enum AuthProvider {
	Auth0 = 'Auth0',
	Azure = 'AzureAd',
	WSO2 = 'Wso2',
}
